import React, { useEffect, useState } from "react";

const HelpAndSupport = ({
  helpData,
  setHelpData,
  originalHelpData,
  handleHelpSubmit
}) => {
  const [hasChanges, setHasChanges] = useState(false);

  // Set default values if helpData is null/undefined
  const safeHelpData = helpData || { mobile: "", whatsapp_number: "" };

  useEffect(() => {
    if (!originalHelpData) return;
    const changed = JSON.stringify(safeHelpData) !== JSON.stringify(originalHelpData);
    setHasChanges(changed);
  }, [safeHelpData, originalHelpData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHelpData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="profile-form-container">
      {/* Support Phone Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Support Phone Number</label>
        <input
          type="text"
          name="mobile"
          value={safeHelpData.mobile}
          onChange={handleChange}
          className="profile-form-input"
          placeholder="Enter support phone number"
        />
      </div>

      {/* Support WhatsApp Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Support WhatsApp Number</label>
        <input
          type="text"
          name="whatsapp_number"
          value={safeHelpData.whatsapp_number}
          onChange={handleChange}
          className="profile-form-input"
          placeholder="Enter WhatsApp number"
        />
      </div>

      {/* Save Button */}
      
        <div className="profile-form-group full-span">
          <button className="profile-save-btn" onClick={handleHelpSubmit}>
            Save Changes
          </button>
        </div>
    
    </div>
  );
};

export default HelpAndSupport;
